import { AnyAction } from 'redux';
import { AxiosResponse } from 'axios';
import { RequestState } from 'modules/types/common';
import { CacheTypes } from 'modules/types/mobileCaching';
import { isDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { testResultsListSlice } from 'store/testResults/reducers.slice';
import { RootDispatch } from 'store/types';
import { SUCCESS_SUFFIX } from '../../lib/constants/network';

export const axiosMiddlewareSuccessOverride = ({
  action,
  next,
  response,
  dispatch
}: {
  action: AnyAction;
  dispatch: RootDispatch;
  next: (action: AnyAction) => void;
  response?: AxiosResponse;
  error?: Error | string;
}) => {
  const uri = response?.config?.baseURL || response?.config?.url;
  const payload =
    !!response?.data?.data && isDispatcherUrl(uri)
      ? {
          ...response,
          data: response.data.data,
          partialErrors: response.data.errors,
          source: response.data.source,
          urlHash: response.data.urlHash
        }
      : response;

  if (action.payload.cacheType === CacheTypes.TEST_RESULTS) {
    const { testResultsListAdded } = testResultsListSlice.actions;
    const consumerId = response.config.headers[DFDHeaders.consumerId];
    dispatch(
      testResultsListAdded({
        consumerId,
        data: payload.data,
        requestState: RequestState.SUCCESS
      })
    );
  }

  const nextAction = {
    meta: {
      previousAction: action
    },
    payload,
    type: `${action.type}${SUCCESS_SUFFIX}`
  };

  next(nextAction);
  return nextAction;
};
